import { MutationHookOptions, useMutation } from '@apollo/client';
import { HANDLE_CSV_IMPORT_COLLECTIONS_MUTATION } from '@frontend/applications/ProductFulfillmentApp/queries/importerManager';
import { HandleCSVImportCollections, HandleCSVImportCollectionsVariables } from '@frontend/applications/ProductFulfillmentApp/queries/types/HandleCSVImportCollections';

type IOptions = MutationHookOptions<HandleCSVImportCollections, HandleCSVImportCollectionsVariables>;

export const useHandleCSVImportCollections = (options: IOptions = {}) => {
  const [mutate, { loading, error, data }] = useMutation<HandleCSVImportCollections, HandleCSVImportCollectionsVariables>(
    HANDLE_CSV_IMPORT_COLLECTIONS_MUTATION,
    {
      ...options,
      onCompleted: (data) => {
        if (data.handleCSVImportCollections) {
          options.onCompleted?.(data);
        }
      },
    },
  );

  return {
    handleCSVImportCollections: mutate,
    isImportingCSVCollections: loading,
    csvImportError: error,
    csvImportResult: data?.handleCSVImportCollections,
  };
};
